// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MisRecetas.module.css */

.MisRecetas_subtitle__sa8fI {
  font-size: 14px;
  color: #667085;
  margin-bottom: 20px;
  margin-top: -12px;
}

.MisRecetas_statsRow__BDIsI {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 16px;
}

.MisRecetas_toolbar__00PFp {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
}

.MisRecetas_tab__0yCnE {
  padding: 7px 16px;
  border-radius: 8px;
  border: 1.5px solid #e4e7ec;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #667085;
  cursor: pointer;
  transition: all 0.15s;
}

.MisRecetas_tab__0yCnE:hover {
  border-color: #2db899;
  color: #2db899;
}
.MisRecetas_tabActive__b8k2l {
  background: #1a3a5c;
  border-color: #1a3a5c;
  color: #fff;
}

/* Fila receta */
.MisRecetas_recetaRow__13pkF {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f2f4f7;
}

.MisRecetas_recetaRow__13pkF:last-child {
  border-bottom: none;
}

.MisRecetas_recetaLeft__IV553 {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex: 1 1;
}

.MisRecetas_pillIcon__murzp {
  width: 40px;
  height: 40px;
  background: #e6f7f3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.MisRecetas_recetaMed__890X2 {
  font-size: 14px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 4px;
}
.MisRecetas_recetaInd__m4rZa {
  font-size: 12px;
  color: #667085;
  margin-bottom: 4px;
  line-height: 1.5;
}
.MisRecetas_recetaMeta__MceHO {
  font-size: 11px;
  color: #98a2b3;
}

.MisRecetas_recetaRight__9eVSM {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
}
.MisRecetas_recetaFecha__fjV0E {
  font-size: 11px;
  color: #98a2b3;
}

/* Botón nueva receta en toolbar */
.MisRecetas_btnNuevaReceta__NnguT {
  margin-left: auto;
  padding: 7px 16px;
  border-radius: 8px;
  border: none;
  background: #1a3a5c;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.MisRecetas_btnNuevaReceta__NnguT:hover {
  background: #2db899;
}

/* Modal pago receta */
.MisRecetas_modalOverlay__hLIDk {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.MisRecetas_modalBox__ahmL3 {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 36px 32px 28px;
  width: 100%;
  max-width: 420px;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
}

.MisRecetas_modalClose__NsMt- {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #98a2b3;
  cursor: pointer;
  line-height: 1;
}

.MisRecetas_modalIcon__tFhVI {
  font-size: 3rem;
  margin-bottom: 10px;
}

.MisRecetas_modalTitle__3BejF {
  font-size: 20px;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 8px;
}

.MisRecetas_modalDesc__iGU1V {
  font-size: 14px;
  color: #667085;
  margin-bottom: 16px;
  line-height: 1.6;
}

.MisRecetas_modalAmount__c0Q2G {
  background: #f0faf7;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 15px;
  color: #1a3a5c;
  margin-bottom: 20px;
}

.MisRecetas_btnPagar__B\\+BNR {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  background: #1a3a5c;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  margin-bottom: 10px;
}
.MisRecetas_btnPagar__B\\+BNR:disabled {
  background: #98a2b3;
  cursor: not-allowed;
}
.MisRecetas_btnPagar__B\\+BNR:not(:disabled):hover {
  background: #2db899;
}

.MisRecetas_btnSimular__Hnf6m {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1.5px solid #2db899;
  background: transparent;
  color: #2db899;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.MisRecetas_btnSimular__Hnf6m:hover {
  background: #e6f7f3;
}
`, "",{"version":3,"sources":["webpack://./src/components/MisRecetas/MisRecetas.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* MisRecetas.module.css */\n\n.subtitle {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 20px;\n  margin-top: -12px;\n}\n\n.statsRow {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.toolbar {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.tab {\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: 1.5px solid #e4e7ec;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #667085;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.tab:hover {\n  border-color: #2db899;\n  color: #2db899;\n}\n.tabActive {\n  background: #1a3a5c;\n  border-color: #1a3a5c;\n  color: #fff;\n}\n\n/* Fila receta */\n.recetaRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.recetaRow:last-child {\n  border-bottom: none;\n}\n\n.recetaLeft {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  flex: 1;\n}\n\n.pillIcon {\n  width: 40px;\n  height: 40px;\n  background: #e6f7f3;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.recetaMed {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 4px;\n}\n.recetaInd {\n  font-size: 12px;\n  color: #667085;\n  margin-bottom: 4px;\n  line-height: 1.5;\n}\n.recetaMeta {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n.recetaRight {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.recetaFecha {\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n/* Botón nueva receta en toolbar */\n.btnNuevaReceta {\n  margin-left: auto;\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: none;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.btnNuevaReceta:hover {\n  background: #2db899;\n}\n\n/* Modal pago receta */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalBox {\n  position: relative;\n  background: #fff;\n  border-radius: 16px;\n  padding: 36px 32px 28px;\n  width: 100%;\n  max-width: 420px;\n  text-align: center;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);\n}\n\n.modalClose {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #98a2b3;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.modalIcon {\n  font-size: 3rem;\n  margin-bottom: 10px;\n}\n\n.modalTitle {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 8px;\n}\n\n.modalDesc {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 16px;\n  line-height: 1.6;\n}\n\n.modalAmount {\n  background: #f0faf7;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 15px;\n  color: #1a3a5c;\n  margin-bottom: 20px;\n}\n\n.btnPagar {\n  width: 100%;\n  padding: 12px;\n  border-radius: 8px;\n  border: none;\n  background: #1a3a5c;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s;\n  margin-bottom: 10px;\n}\n.btnPagar:disabled {\n  background: #98a2b3;\n  cursor: not-allowed;\n}\n.btnPagar:not(:disabled):hover {\n  background: #2db899;\n}\n\n.btnSimular {\n  width: 100%;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1.5px solid #2db899;\n  background: transparent;\n  color: #2db899;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.btnSimular:hover {\n  background: #e6f7f3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `MisRecetas_subtitle__sa8fI`,
	"statsRow": `MisRecetas_statsRow__BDIsI`,
	"toolbar": `MisRecetas_toolbar__00PFp`,
	"tab": `MisRecetas_tab__0yCnE`,
	"tabActive": `MisRecetas_tabActive__b8k2l`,
	"recetaRow": `MisRecetas_recetaRow__13pkF`,
	"recetaLeft": `MisRecetas_recetaLeft__IV553`,
	"pillIcon": `MisRecetas_pillIcon__murzp`,
	"recetaMed": `MisRecetas_recetaMed__890X2`,
	"recetaInd": `MisRecetas_recetaInd__m4rZa`,
	"recetaMeta": `MisRecetas_recetaMeta__MceHO`,
	"recetaRight": `MisRecetas_recetaRight__9eVSM`,
	"recetaFecha": `MisRecetas_recetaFecha__fjV0E`,
	"btnNuevaReceta": `MisRecetas_btnNuevaReceta__NnguT`,
	"modalOverlay": `MisRecetas_modalOverlay__hLIDk`,
	"modalBox": `MisRecetas_modalBox__ahmL3`,
	"modalClose": `MisRecetas_modalClose__NsMt-`,
	"modalIcon": `MisRecetas_modalIcon__tFhVI`,
	"modalTitle": `MisRecetas_modalTitle__3BejF`,
	"modalDesc": `MisRecetas_modalDesc__iGU1V`,
	"modalAmount": `MisRecetas_modalAmount__c0Q2G`,
	"btnPagar": `MisRecetas_btnPagar__B+BNR`,
	"btnSimular": `MisRecetas_btnSimular__Hnf6m`
};
export default ___CSS_LOADER_EXPORT___;
